import React, { Component } from 'react';
import { Card, CardImg, CardText, CardBody,
    CardTitle, Breadcrumb, BreadcrumbItem,
    Nav, NavItem, Button, Modal, ModalHeader,
    ModalBody, Label, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Control, LocalForm, Errors } from 'react-redux-form';
import { Loading } from './LoadingComponent';
import { CreateParagraphs } from './ReviewdetailComponent.js';
import Chess from './ChessComponent';
import ChessControls from './ChessControlsComponent';

    class UpdateDetail extends React.Component{
      constructor(props) {
         super(props);

         this.state = { index: 0, squareColor: 'green', pieceType: 'image'};

      }

    getPrevious(id, max, min){
      if(id == min){
        return max;
      }
      return id - 1;
    }

    getNext(id, max, min){
      if(id == max){
        return min;
      }
      return id + 1;
    }

    updateStateIndexFromChild = (index) => {
      this.setState({
        index
      })
    }

    updateStateColorFromChild = (squareColor) => {
      this.setState({
        squareColor
      })
    }

    updateStatePieceTypeFromChild = (pieceType) => {
      console.log(pieceType)
      this.setState({
        pieceType
      })
    }

      render(){
        if (this.props.isLoading) {
            return(
                <div className="container">
                    <div className="row">
                        <Loading />
                    </div>
                </div>
            );
        }
        else if (this.props.errMess) {
            return(
                <div className="container">
                    <div className="row">
                        <h4>{this.props.errMess}</h4>
                    </div>
                </div>
            );
        }
        else if(this.props.update != null)
        {
                var style = this.props.update.diagrams[this.state.index] == '' ? {display: 'none'} : {display: 'block'}
		            return (
                <div className="container">
                <div className="row">
                    <Link to={`/updates/${this.getPrevious(this.props.update.id, this.props.max, this.props.min)}`}>
                      <button class="btn btn-primary">
                         Previous Article
                      </button>
                    </Link>
                    <Breadcrumb>
                        <BreadcrumbItem><Link to="/updates">Updates</Link></BreadcrumbItem>
                        <BreadcrumbItem active>{this.props.update.name}</BreadcrumbItem>
                    </Breadcrumb>
                    <Link to={`/updates/${this.getNext(this.props.update.id, this.props.max, this.props.min)}`}>
                      <button class="btn btn-primary">
       		               Next Article
       		            </button>
                    </Link>
                    <div className="col-12">
                        <h3>{this.props.update.name}</h3>
                        <hr />
                    </div>
                </div>
                <div className="row">
                    <div>
                        <CreateParagraphs description={this.props.update.description}/>
                    </div>
                </div>
                <div className="row">
                  <div className="col-12 col-md m-1">
                    <Chess fen={this.props.update.diagrams[this.state.index]} squareColor={this.state.squareColor} pieceType={this.state.pieceType}/>
                  </div>
                </div>
            <ChessControls update={this.props.update} updateStateIndexFromChild = {this.updateStateIndexFromChild} updateStateColorFromChild = {this.updateStateColorFromChild} updateStatePieceTypeFromChild = {this.updateStatePieceTypeFromChild}/>
                </div>
            );
        }
        else
		return (
		   <div></div>
		);
      }
    }

export default UpdateDetail;
